import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import ChevronDown from '../Icons/ChevronDown.js';
import ChevronUp from '../Icons/ChevronUp.js';
import HTMLEmail from './HTMLEmail.js';
const Email = (props) => {
    const lang = useSelector((s) => s.lang);
    const [open, setOpen] = useState(false);
    const { interaction } = props;
    const email = interaction.details;
    return (React.createElement(EmailStyled, { style: props.style },
        React.createElement(Body, { open: props.noToggle || open, onClick: () => {
                setOpen(!open);
            } },
            React.createElement("div", null, typeof email.html === 'string' ? (React.createElement(HTMLEmail, { html: email.html })) : (React.createElement(PlaintextBody, null, email.body))),
            !props.noToggle && (React.createElement(ReadMore, { open: open },
                React.createElement(ReadMoreText, null,
                    open ? lang.interactions.readLess : lang.interactions.readMore,
                    open ? (React.createElement(ChevronUp, { style: {
                            margin: '-0.1em 0em -0.1em 0.2em',
                        } })) : (React.createElement(ChevronDown, { style: {
                            margin: '-0.1em 0em -0.1em 0.2em',
                        } }))))))));
};
export default Email;
const EmailStyled = styled.div `
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: ${-THEME.GRID_SPACING}px;
`;
const Body = styled.div `
  position: relative;
  & > div {
    max-height: ${(props) => (props.open ? '50000px' : '115px')};
    overflow: hidden;
  }
`;
const ReadMoreText = styled.p `
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
  margin: 2em 0 0 0;
  color: ${THEME.COLOR_ACCENT};
`;
const ReadMore = styled.div `
  ${(props) => props.open
    ? ''
    : `
        background: rgb(255,255,255);
        background: linear-gradient(0deg, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%);
        position: absolute;
  `} bottom: 0;
  width: 100%;
  padding-bottom: 10px;
  cursor: pointer;
`;
const PlaintextBody = styled.div `
  white-space: pre-wrap;
  overflow-wrap: break-word;
  font-family: inherit;
`;
//# sourceMappingURL=Email.js.map